import React from 'react';
import { EntityEditFetcher } from '../components/EntityEditFetcher';
import typeIntro from '../static/introspection/Company360.json';
import inputTypeIntro from '../static/introspection/Company360CreateInput.json';
import { ENTITY } from '../utils/entities';
import { Company360CreateMutation } from 'graphql/mutations/Company360CreateMutation';
import { Company360DetailQuery } from 'graphql/query/Company360DetailQuery';
import { graphqlQuery } from 'utils/graphql';
import { ACTIONS, generateUrl } from 'utils/urls';
import { company360Transformer } from 'utils/entities/company360';

const Company360Create = ({ id }) => (
	<EntityEditFetcher
		fetcher={id ? graphqlQuery(Company360DetailQuery, { id }) : null}
		create={true}
		clone={!!id}
		id={id}
		mutation={Company360CreateMutation}
		typeIntro={typeIntro}
		inputTypeIntro={inputTypeIntro}
		entityName={ENTITY.COMPANY_360}
		customDetailUrl={(newId) =>
			generateUrl(ENTITY.COMPANY_360, ACTIONS.DETAIL, newId) +
			'?flow=postcreate'
		}
		fields={[
			'companyLevel',
			'Company',
			'Service',
			'FoodService',
			'Retailer',
			'Brand',
		]}
		transformer={company360Transformer}
	/>
);

export { Company360Create };